type ProductHtmlSectionProps = {
  title: string;
  html: string;
};

export function ProductHtmlSection({ title, html }: ProductHtmlSectionProps) {
  if (!html || html === '<p><br></p>') {
    return null;
  }

  return (
    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-secondary-900">{title}</h2>
      <div
        className="prose prose-secondary max-w-none text-secondary-700 [&_img]:max-w-full [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </section>
  );
}
